import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BillingDetails from "~/components/Subscription/BillingDetails";
import BillingPaymentMethod from "~/components/Subscription/BillingPaymentMethod/BillingPaymentMethod";
import LastInvoice from "~/components/Subscription/LastInvoice";
import { fetchAllInvoices } from "~/store/actions/actions.subscription";
import { getIsCanceled, getIsSuspendedTrial, getIsTrial } from "~/store/selectors/selector.accountSettings";
import {
  isPaymentMethodAvailable,
  isBillingAddressAvailable,
  isPrePaidPaymentMethod,
} from "~/store/selectors/selector.billingPaymentMethod";
import { getLastInvoice } from "~/store/selectors/selector.subscription";

export const AdditionalBillingInfo = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllInvoices());
  }, [dispatch]);

  const isMethodAvailable = useSelector((state) => isPaymentMethodAvailable(state));
  const isPrePaidPaymentMethodAvailable = useSelector((state) => isPrePaidPaymentMethod(state));
  const isCanceled = useSelector(getIsCanceled);
  const isAddressAvailable = useSelector((state) => isBillingAddressAvailable(state));
  const lastInvoice = useSelector(getLastInvoice);
  const isTrial = useSelector((state) => getIsTrial(state));
  const isSuspendedTrial = useSelector((state) => getIsSuspendedTrial(state));
  return (
    <>
      {!isTrial && !isSuspendedTrial ? (
        <div className="tw-mt-14">
          {isMethodAvailable || isPrePaidPaymentMethodAvailable ? (
            <BillingPaymentMethod isCanceled={isCanceled} />
          ) : null}
          {isAddressAvailable ? <BillingDetails isCanceled={isCanceled} /> : null}
          {lastInvoice ? <LastInvoice lastInvoice={lastInvoice} /> : null}
        </div>
      ) : null}
    </>
  );
};
